import React, {useEffect, useState} from 'react';
import {Button, Grid, Typography} from '@material-ui/core';
import InputField from "../../../../FormikUtils/InputField";
import {ErrorMessage, FieldArray, useFormikContext} from "formik";
import NumberField from "../../../../FormikUtils/NumberField";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import useStyles from '../styles';

export default function DetailsForm(props) {
    const {
        formField: {
            detalleEquipoElectronico: {
                descripcionElectronico,
                sumaAseguradaElectronico,
                codigoElectronico,
                codigoGrupoElectronico
            },
            detalleBicicletas: {
                descripcionBicicletas,
                sumaAseguradaBicicletas,
                codigoBicicletas,
                codigoGrupoBicicletas
            },
            detalleMonopatines: {
                descripcionMonopatines,
                sumaAseguradaMonopatines,
                codigoMonopatines,
                codigoGrupoMonopatines
            },
        },
        errors
    } = props;
    const classes = useStyles();
    const {values} = useFormikContext();
    const [bicicletasDetailsRequired, setBicicletasDetailsRequired] = useState({selected: false, sumaAsegurada: 0});
    const [monopatinesDetailsRequired, setMonopatinesDetailsRequired] = useState({selected: false, sumaAsegurada: 0});
    const [equipoElectronicoDetailsRequired, setEquipoElectronicoDetailsRequired] = useState({
        selected: false,
        sumaAsegurada: 0
    });

    const equipoElectronicoVacio = {
        [descripcionElectronico.name]: '',
        [sumaAseguradaElectronico.name]: '',
        [codigoElectronico.name]: 201,
        [codigoGrupoElectronico.name]: 34,
    };
    const bicicletasVacio = {
        [descripcionBicicletas.name]: '',
        [sumaAseguradaBicicletas.name]: '',
        [codigoBicicletas.name]: 209,
        [codigoGrupoBicicletas.name]: 31,
    };
    const monopatinesVacio = {
        [descripcionMonopatines.name]: '',
        [sumaAseguradaMonopatines.name]: '',
        [codigoMonopatines.name]: 210,
        [codigoGrupoMonopatines.name]: 31,
    };

    const checkError = (prod) => {
        let prodName;
        if (prod === 1) prodName = "detalleBicicletas"
        if (prod === 2) prodName = "detalleMonopatines"
        if (prod === 3) prodName = "detalleEquipoElectronico"

        if (errors[prodName] !== undefined)
            return (errors[prodName].includes("Las sumas declaradas deben coincidir con las aseguradas"))
        else
            return false
    }

    useEffect(() => {
        values.coberturas.map((cob) => {
            if (cob.numeroCobertura === "48") {
                setBicicletasDetailsRequired({selected: true, sumaAsegurada: cob.sumaAsegurada})
            }
            if (cob.numeroCobertura === "49") {
                setMonopatinesDetailsRequired({selected: true, sumaAsegurada: cob.sumaAsegurada})
            }
            if (cob.numeroCobertura === "26")
                setEquipoElectronicoDetailsRequired({selected: true, sumaAsegurada: cob.sumaAsegurada})
        })
    }, []);

    function currencyFormat(numString) {
        numString = numString.toString().replace(/\./g, "")
        numString = numString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return numString
    }

    const buttonsToShow = (index, length, arrayHelpers, emptyArray) => {
        if (length === 1) {
            return (<Grid item xs={1}>
                <Button variant='outlined' size="small"
                        style={{padding: "0", marginTop: "16px"}}
                        onClick={() => arrayHelpers.push(emptyArray)}>
                    <AddIcon/>
                </Button>
            </Grid>)
        } else if (index !== length - 1) {
            return (<Grid item xs={1}>
                <Button variant='outlined' size="small"
                        style={{padding: "0", marginTop: "16px"}}
                        onClick={() => arrayHelpers.remove(index)}>
                    <RemoveIcon/>
                </Button>
            </Grid>)
        } else {
            return (
                <Grid item xs={1}>
                    <div className={classes.fieldArrayButtonsDiv}>
                        <Button variant='outlined' size="small"
                                className={classes.fieldArrayButtons}
                                onClick={() => arrayHelpers.remove(index)}>
                            <RemoveIcon/>
                        </Button>
                        <Button variant='outlined' size="small"
                                className={classes.fieldArrayButtons}
                                onClick={() => arrayHelpers.push(emptyArray)}>
                            <AddIcon/>
                        </Button>
                    </div>
                </Grid>
            )
        }
    }

    return (
        <React.Fragment>
            {bicicletasDetailsRequired.selected &&
            <>
                <Typography className={classes.tableHeader} style={{margin: "32px 0px 16px 16px"}}>
                    Declaración de objetos asegurados bajo la cobertura "Robo de Bicicletas"
                </Typography>

                <div style={{
                    display: "flex",
                    flexDirection: "column",
                }}>
                    <FieldArray name='detalleBicicletas'>{(arrayHelpers) => (
                        values.detalleBicicletas.map((item, index) => (
                            <Grid key={index} item container spacing={4} direction='row'
                                  style={{alignItems: "center", justifyContent: "center"}}>
                                <Grid item xs={4}>
                                    <InputField
                                        name={`detalleBicicletas[${index}].${descripcionBicicletas.name}`}
                                        label={descripcionBicicletas.label}
                                        value={item.descripcionBicicletas}
                                        fullWidth
                                        textTransform={'capitalize'}/>
                                </Grid>
                                <Grid item xs={4}>
                                    <NumberField
                                        notCobertura={true}
                                        errorText={errors.detalleBicicletas !== undefined && errors.detalleBicicletas[index] !== undefined ? errors.detalleBicicletas[index].sumaAseguradaBicicletas : 'Ingrese un número válido'}
                                        value={currencyFormat(item.sumaAseguradaBicicletas)}
                                        name={`detalleBicicletas[${index}].${sumaAseguradaBicicletas.name}`}
                                        label={sumaAseguradaBicicletas.label}
                                        inputProps={{style: {textAlign: 'right'}}}
                                    />
                                </Grid>

                                {buttonsToShow(index, values.detalleBicicletas.length, arrayHelpers, bicicletasVacio)}
                            </Grid>
                        ))
                    )}</FieldArray>
                    {checkError(1)
                    &&
                    <>
                        <ErrorMessage name='detalleBicicletas'
                                      render={msg => <div className={classes.errorMessage}>{msg}</div>}/>
                        <p className={classes.errorMessage}> ($ {bicicletasDetailsRequired.sumaAsegurada})</p>
                    </>}
                </div>
            </>}
            {monopatinesDetailsRequired.selected &&
            <>
                <Typography className={classes.tableHeader} style={{margin: "32px 0px 16px 16px"}}>
                    Declaración de objetos asegurados bajo la cobertura "Robo de Monopatines"
                </Typography>

                <div style={{
                    display: "flex",
                    flexDirection: "column",
                }}>
                    <FieldArray name='detalleMonopatines'>{(arrayHelpers) => (
                        values.detalleMonopatines.map((item, index) => (
                            <Grid key={index} item container spacing={4} direction='row'
                                  style={{alignItems: "center", justifyContent: "center"}}>
                                <Grid item xs={4}>
                                    <InputField
                                        name={`detalleMonopatines[${index}].${descripcionMonopatines.name}`}
                                        label={descripcionMonopatines.label}
                                        value={item.descripcionMonopatines}
                                        fullWidth
                                        textTransform={'capitalize'}/>
                                </Grid>
                                <Grid item xs={4}>
                                    <NumberField
                                        notCobertura={true}
                                        errorText={errors.detalleMonopatines !== undefined && errors.detalleMonopatines[index] !== undefined ? errors.detalleMonopatines[index].sumaAseguradaMonopatines : 'Ingrese un número válido'}
                                        value={currencyFormat(item.sumaAseguradaMonopatines)}
                                        name={`detalleMonopatines[${index}].${sumaAseguradaMonopatines.name}`}
                                        label={sumaAseguradaMonopatines.label}
                                        inputProps={{style: {textAlign: 'right'}}}
                                    />
                                </Grid>

                                {buttonsToShow(index, values.detalleMonopatines.length, arrayHelpers, monopatinesVacio)}
                            </Grid>
                        ))
                    )}</FieldArray>
                    {checkError(2)
                    &&
                    <>
                        <ErrorMessage name='detalleMonopatines'
                                      render={msg => <div className={classes.errorMessage}>{msg}</div>}/>
                        <p className={classes.errorMessage}> ($ {monopatinesDetailsRequired.sumaAsegurada})</p>
                    </>}
                </div>
            </>}
            {equipoElectronicoDetailsRequired.selected &&
            <>
                <Typography className={classes.tableHeader} style={{margin: "32px 0px 16px 16px"}}>
                    Declaración de objetos asegurados bajo la cobertura "Robo de objetos
                    varios"
                </Typography>

                <div style={{
                    display: "flex",
                    flexDirection: "column",
                }}>
                    <FieldArray name='detalleEquipoElectronico'>{(arrayHelpers) => (
                        values.detalleEquipoElectronico.map((item, index) => (
                            <Grid key={index} item container spacing={4} direction='row'
                                  style={{alignItems: "center", justifyContent: "center"}}>
                                <Grid item xs={4}>
                                    <InputField
                                        name={`detalleEquipoElectronico[${index}].${descripcionElectronico.name}`}
                                        label={descripcionElectronico.label}
                                        value={item.descripcionElectronico}
                                        fullWidth
                                        textTransform={'capitalize'}/>
                                </Grid>
                                <Grid item xs={4}>
                                    <NumberField
                                        notCobertura={true}
                                        errorText={errors.detalleEquipoElectronico !== undefined && errors.detalleEquipoElectronico[index] !== undefined ? errors.detalleEquipoElectronico[index].sumaAseguradaElectronico : 'Ingrese un número válido'}
                                        value={currencyFormat(item.sumaAseguradaElectronico)}
                                        name={`detalleEquipoElectronico[${index}].${sumaAseguradaElectronico.name}`}
                                        label={sumaAseguradaElectronico.label}
                                        inputProps={{style: {textAlign: 'right'}}}
                                    />
                                </Grid>

                                {buttonsToShow(index, values.detalleEquipoElectronico.length, arrayHelpers, equipoElectronicoVacio)}
                            </Grid>
                        ))
                    )}</FieldArray>

                    {checkError(3)
                    &&
                    <>
                        <ErrorMessage name='detalleEquipoElectronico'
                                      render={msg => <div className={classes.errorMessage}>{msg}</div>}/>
                        <p className={classes.errorMessage}> ($ {equipoElectronicoDetailsRequired.sumaAsegurada})</p>
                    </>}
                </div>
            </>}
        </React.Fragment>
    );
}